var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFacebookBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#304FFD",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 24C35.625 29.8125 31.3594 34.6406 25.7812 35.4844V27.375H28.5L29.0156 24H25.7812V21.8438C25.7812 20.9062 26.25 20.0156 27.7031 20.0156H29.1562V17.1562C29.1562 17.1562 27.8438 16.9219 26.5312 16.9219C23.9062 16.9219 22.1719 18.5625 22.1719 21.4688V24H19.2188V27.375H22.1719V35.4844C16.5938 34.6406 12.375 29.8125 12.375 24C12.375 17.5781 17.5781 12.375 24 12.375C30.4219 12.375 35.625 17.5781 35.625 24Z",
    fill: "#0071CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookBg);
export default __webpack_public_path__ + "static/media/icFacebookBg.aafe9178dd029ce6480abb488316c7b1.svg";
export { ForwardRef as ReactComponent };